/**
 * Fire-and-forget guest funnel events for Try as Guest analytics.
 */
import studentApi from './studentApi';

const GUEST_PREFIX = '/api/guest';

export type GuestEntryMethod = 'SEARCH' | 'BY_LOCATION' | 'QUICK_COURSE';

export interface GuestEventPayload {
  eventType: string;
  entryMethod?: GuestEntryMethod;
  countryId?: number;
  councilId?: number;
  schoolId?: number;
  courseId?: number;
  topicId?: number;
  metadata?: Record<string, unknown>;
}

/** Record a guest journey event (no-op if guestId missing). */
export function trackGuestEvent(guestId: string | null | undefined, payload: GuestEventPayload): void {
  if (!guestId) return;
  studentApi
    .post(`${GUEST_PREFIX}/events`, payload, { headers: { 'X-Guest-Id': guestId } })
    .catch(() => {
      /* analytics must not block UX */
    });
}
